
















import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";
import { IHisInformationItemDefaultSelectBehavior, HisInformationItemDefaultSelectKinds } from "../../../../domain/format/objects";
import { default as OptionalFeatureEditor } from "./OptionalFeatureEditor.vue";

@Component({
  components: {
    OptionalFeatureEditor,
    OptionDropDownSelector,
  }
})

export default class HisInformationItemDefaultSelectBehaviorEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: IHisInformationItemDefaultSelectBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IHisInformationItemDefaultSelectBehavior) => T, defaultValue: T) => T;

  @Prop()
  defaultSelectOptions: HisInformationItemDefaultSelectKinds[];

  get isEnable(): boolean {
    return this.readPropertyOrDefault(s => s.isEnable, false);
  }
  
  get kind(): HisInformationItemDefaultSelectKinds {
    return this.readPropertyOrDefault(s => s.kind, HisInformationItemDefaultSelectKinds.Top);
  }

  set kind(value: HisInformationItemDefaultSelectKinds) {
    this.writePropertyWhenValid(s => s.kind = value);
  }

  get kindOptions(): StandardOption<number>[] {
    return Enumerable.from(this.allOptions)
      .where(o => 0 <= this.defaultSelectOptions.indexOf(o.value))
      .toArray();
  }

  allOptions: StandardOption<number>[] = [
    new StandardOption<number>("先頭", HisInformationItemDefaultSelectKinds.Top),
    new StandardOption<number>("作成日", HisInformationItemDefaultSelectKinds.CreatedDate),
    new StandardOption<number>("末尾", HisInformationItemDefaultSelectKinds.Bottom),
  ];
}
